export default __webpack_public_path__ + "static/media/ib.b11ec866.pdf";